import { Button } from '@/components'
import { RewardButtonWithState } from '@/components/molecules/rewards/RewardButton'
import React from 'react'
import { useTranslation } from 'react-i18next'
import type { PresentTypeBasedComponentsProps } from './presentTypeComponentType'

/**
 * PresentType 軸の/rewards/detail ページで使用されるコンポーネント
 * */
export const PresentType06GifteeComponents = ({
  selectedType,
  presentType,
  checkCondition,
  onStartDownload,
  onStartDownloadOnly,
  onStartDownloadWithLottery,
  onGoDirectToConfirm,
  onDecideUserPresentItem,
  buttonDisabled = false,
  isApplicationForm,
  presentItemList,
  userRewardState,
  isStock,
  inPeriod,
  userPresentItem,
  hasQuestionnaire,
}: PresentTypeBasedComponentsProps) => {
  const { t } = useTranslation()
  if (presentType !== 'Giftee') {
    return null
  }
  // 在庫がなくなった場合
  if (!isStock) {
    // - 特典リストを出す場合: すぐに「終了しました」を出す
    // - 特典リストを出さない場合: 特典を獲得していないければ、「終了しました」を出す。
    const skipSpecificCondition1 = userRewardState === 'RECEIVED' || userRewardState === 'EXCHANGED'
    if (skipSpecificCondition1 && !presentItemList) {
      // skip: すぐに「終了しました」を出さない場合
    } else {
      return (
        <RewardButtonWithState
          inPeriod={inPeriod}
          isStock={isStock}
          checkCondition={checkCondition}
          selectedType={selectedType}
          presentType={presentType}
          isApplicationForm={isApplicationForm}
        />
      )
    }
  }
  if (!inPeriod) {
    return (
      <RewardButtonWithState
        inPeriod={inPeriod}
        isStock={isStock}
        checkCondition={checkCondition}
        selectedType={selectedType}
        presentType={presentType}
        isApplicationForm={isApplicationForm}
      />
    )
  }
  //
  return (
    <>
      {selectedType === 1 && (
        <>
          {presentItemList ? (
            <>
              <Button
                text={t('reward_detail.receive_your_prize_2', '賞品を受け取る')}
                width="w-9/12"
                disabled={buttonDisabled || !checkCondition}
                onClick={onStartDownload}
              />
            </>
          ) : (
            <>
              <Button
                text={t('reward_detail.receive_your_prize_2', '賞品を受け取る')}
                width="w-9/12"
                disabled={buttonDisabled || (userRewardState !== 'EXCHANGED' && !checkCondition)}
                onClick={() => {
                  if (userRewardState === 'CONDITION_MET') {
                    let windowRef = null
                    if (hasQuestionnaire) {
                      windowRef = window.open('about:blank', '_blank')
                    }
                    onDecideUserPresentItem().then((userPresentId) => onGoDirectToConfirm({ userPresentId, windowRef }))
                  } else {
                    onGoDirectToConfirm({})
                  }
                }}
              />
            </>
          )}
        </>
      )}
      {selectedType === 2 && (
        <>
          {presentItemList ? (
            <Button
              text={t('reward_detail.receive_your_prize_2', '賞品を受け取る')}
              width="w-9/12"
              disabled={buttonDisabled || !checkCondition}
              onClick={onStartDownload}
            />
          ) : (
            <>
              <Button text={'存在しないパターン'} width="w-9/12" disabled={true} />
            </>
          )}
        </>
      )}
      {selectedType === 3 && (
        <>
          {presentItemList ? (
            <>
              <Button
                text={t('reward_detail.lottery', '抽選する')}
                width="w-9/12"
                disabled={buttonDisabled || !checkCondition}
                onClick={checkCondition ? onStartDownloadWithLottery : onStartDownload}
              />
            </>
          ) : (
            <>
              {userPresentItem?.user_presents.length === 0 && (
                <>
                  <Button
                    text={t('reward_detail.lottery', '抽選する')}
                    width="w-9/12"
                    disabled={buttonDisabled || !checkCondition}
                    onClick={onStartDownloadWithLottery}
                  />
                </>
              )}
              {userPresentItem?.user_presents.length === 1 && (
                <>
                  <Button
                    text={t('reward_detail.receive_your_prize_2', '賞品を受け取る')}
                    width="w-9/12"
                    disabled={
                      buttonDisabled ||
                      (userRewardState !== 'EXCHANGED' && !checkCondition) ||
                      userPresentItem.user_presents[0].user_present_items[0].is_lost
                    }
                    onClick={() => {
                      onGoDirectToConfirm({})
                    }}
                  />
                </>
              )}
              {userPresentItem?.user_presents.length > 1 && (
                <>
                  <Button text={'存在しないパターン'} width="w-9/12" disabled={true} />
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}
